import React from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";
import { DocumentosAgrupados } from "../DocumentosAgrupados/DocumentosAgrupados";
import FolderSharedIcon from '@mui/icons-material/FolderShared';

export const CustomerDocuments = ({ user, oferta, clienteSeleccionado }) => {
    return (
        <Box sx={{ height: "600px", display: 'flex', flexDirection: 'column' }}>

            <Typography variant="body2" color="textSecondary">
                {clienteSeleccionado
                    ? `Archivos de: ${clienteSeleccionado.razonSocial}`
                    : "Seleccione un cliente para ver documentos"}
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* Contenedor con Scroll para los documentos */}
            <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
                {clienteSeleccionado ? (
                    <DocumentosAgrupados
                        idUsuario={user?.idPerfil}
                        planta={oferta}
                        cliente={clienteSeleccionado.razonSocial}
                        elementoActivo="Privado"
                    />
                ) : (
                    <Typography
                        variant="body2"
                        sx={{ fontStyle: 'italic', textAlign: 'center', mt: 4, color: 'text.disabled' }}
                    >
                        No hay documentos disponibles.
                    </Typography>
                )}
            </Box>
        </Box>
    );
};